/**
 * Whether a case shows "Send to RRQ" (T-154): the feature flag is on AND the
 * case is a Quebec case. Region decides, not benefits_program — an Ontario
 * case with a QPP override still files nothing with Retraite Québec through
 * this. The backend refuses non-Quebec cases too.
 */
export function canSendToRrq(record: { region?: string | null } | null | undefined, flagOn: boolean): boolean {
  return flagOn && (record?.region || '').toString().toLowerCase() === 'quebec';
}
